import { Button, Group, Text, Dialog } from '@mantine/core';

interface ConfirmDialogProps {
  opened: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title?: string;
  message?: string;
  confirmLabel?: string;
  cancelLabel?: string;
}

export const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
  opened = false,
  onClose,
  onConfirm,
  title = 'Confirm',
  message = 'Are you sure?',
  confirmLabel = 'Yes',
  cancelLabel = 'No',
}) => (
  <Dialog
    opened={!!opened}
    onClose={onClose}
    title={title || ''}
  >
    <Text mb="md">{message || ''}</Text>
    <Group justify="flex-end">
      <Button variant="default" onClick={onClose}>{cancelLabel || 'No'}</Button>
      <Button color="red" onClick={() => { onConfirm(); onClose(); }}>
        {confirmLabel || 'Yes'}
      </Button>
    </Group>
  </Dialog>
);